import {z} from 'zod';
import {zDateTime, zNumberToString} from '@brunata-angular/util';

const reportingAccountSchema = z.object({
    accountPeriodId: zNumberToString,
    accountHeading: z.string().nullable(),
    accountNo: z.number(),
    periodStartDate: zDateTime,
    periodEndDate: zDateTime,
    consumerState: z.enum(['OPEN', 'NOT_OPEN', 'VIEW', 'OTHER'] as const).nullable(),
    costState: z.enum(['OPEN', 'NOT_OPEN', 'VIEW', 'OTHER'] as const).nullable(),
    hasConsumerAttachments: z.boolean(),
    hasBegunConsumerReporting: z.boolean(),

    consumerAmountsAcceptedDate: zDateTime.nullable(),
    costsStartDate: zDateTime.nullable(),
    costsAcceptedDate: zDateTime.nullable(),
    vatOnFee: z.enum(['J', 'N', 'R', 'C'] as const).nullable(),
});

export const reportingBuildingPeriodSchema = z.object({
    buildingName: z.string().nullable(),
    address1: z.string().nullable(),
    address2: z.string().nullable(),
    countryCode: z.string(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    buildingNo: zNumberToString,
    periodId: zNumberToString,
    consumersStartDate: zDateTime.nullable(),
    consumersAcceptedDate: zDateTime.nullable(),
    consumerDigits: z.number().nullable(),
    accounts: z.array(reportingAccountSchema),
});

export type ReportingBuildingPeriod = z.infer<typeof reportingBuildingPeriodSchema>;
export type ReportingAccount = z.infer<typeof reportingAccountSchema>;
